import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "color", "justifyStart", "className", "containerClass", "tooltip", "header", "isCircled", "style", "classes"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import defaultClasses from "./icon.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
var Icon = _ref => {
  var {
      name,
      color,
      justifyStart,
      className,
      containerClass,
      tooltip,
      header,
      isCircled = false,
      style,
      classes
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var mergedClasses = mergeClasses(defaultClasses, classes);
  var rootClassName = defaultClasses[name];
  var rootClassColor = defaultClasses[color];
  var headerIconClass = header ? mergedClasses.headerIconStyle : "";
  var styles = isCircled ? _objectSpread(_objectSpread({}, style), {}, {
    border: "1px solid",
    borderRadius: "50%",
    padding: "2px"
  }) : style;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "icon-container ".concat(justifyStart ? "uk-flex-left" : "", " ").concat(name, " ").concat(mergedClasses.iconContainer, " ").concat(containerClass ? containerClass : "", " ").concat(headerIconClass)
  }, otherProps), /*#__PURE__*/React.createElement("i", {
    className: "icon ".concat(rootClassName, " ").concat(rootClassColor ? rootClassColor : "", " ").concat(className ? className : ""),
    style: styles,
    "uk-tooltip": tooltip ? "title: ".concat(tooltip, "; offset: 5") : ""
  }));
};

/**
 *
 * @param {IconNames} name
 * @returns
 */
export var onlyIcon = name => "icon ".concat(defaultClasses[name]);
export default Icon;